var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912_8603)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_912_8603",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.619 0H2.38095C1.06599 0 0 1.07452 0 2.4V15.6C0 16.9255 1.06599 18 2.38095 18H22.619C23.934 18 25 16.9255 25 15.6V2.4C25 1.07452 23.934 0 22.619 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_912_8603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.619 0H2.38095C1.06599 0 0 1.07452 0 2.4V15.6C0 16.9255 1.06599 18 2.38095 18H22.619C23.934 18 25 16.9255 25 15.6V2.4C25 1.07452 23.934 0 22.619 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6668 8.99995C16.6668 11.3196 14.8014 13.2 12.5002 13.2C10.199 13.2 8.3335 11.3196 8.3335 8.99995C8.3335 7.65595 11.1311 7.09195 13.4859 7.30435C13.7359 7.23715 14.0049 7.19995 14.2859 7.19995C15.6014 7.19995 16.6668 8.00635 16.6668 8.99995Z",
    fill: "#0048AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9049 8.40005C11.9049 8.40005 12.9704 7.20005 14.2859 7.20005C15.6014 7.20005 16.6668 8.00645 16.6668 9.00005C16.6668 6.68045 14.8014 4.80005 12.5002 4.80005C10.8371 4.80005 9.40135 5.78165 8.7335 7.20245C8.3335 8.40005 8.3335 8.75045 8.3335 9.00005C8.92873 9.60005 9.59064 9.60005 10.1192 9.60005C10.6478 9.60005 11.1228 9.36845 11.4502 9.00005L11.9049 8.40005Z",
    fill: "#CD0027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.857 6.0001H20.2379L17.857 3.6001H16.6665L17.857 6.0001ZM7.14267 6.0001H4.76172L7.14267 3.6001H8.33315L7.14267 6.0001ZM17.857 12.0001H20.2379L17.857 14.4001H16.6665L17.857 12.0001ZM7.14267 12.0001H4.76172L7.14267 14.4001H8.33315L7.14267 12.0001Z",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.619 0.600098H2.38093C1.39471 0.600098 0.595215 1.40599 0.595215 2.4001V15.6001C0.595215 16.5942 1.39471 17.4001 2.38093 17.4001H22.619C23.6052 17.4001 24.4047 16.5942 24.4047 15.6001V2.4001C24.4047 1.40599 23.6052 0.600098 22.619 0.600098Z",
    stroke: "black",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912_8603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/KO.23148fb40492e1828bb73acd166255e2.svg";
export { ForwardRef as ReactComponent };